module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/free-country-rc-6d8ae4734e706a62f9631bcbdfedc72f.webp";